export default "__VITE_ASSET__CMOk4uKh__"